import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err, fallback = "Algo deu errado. Tente novamente.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Cache leve em memória: evita chamadas duplicadas (StrictMode/dev e componentes que
// pedem o mesmo dado). Em produção derruba requisições repetidas na mesma visita.
const _cache = new Map();
export function cachedGet(path, ttlMs = 60000) {
  const hit = _cache.get(path);
  if (hit && Date.now() - hit.t < ttlMs) return hit.p;
  const p = api.get(path).then((r) => r.data);
  _cache.set(path, { t: Date.now(), p });
  p.catch(() => _cache.delete(path));
  return p;
}
export const getCategories = () => cachedGet("/categories");
export const clearApiCache = () => _cache.clear();

/** Registra clique em "Comprar pelo WhatsApp" sem bloquear a navegação (sendBeacon). */
export function trackWaClick(productId, source = "produto") {
  try {
    const payload = JSON.stringify({ product_id: productId || "", source });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/track/wa-click`, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(`${API}/track/wa-click`, { method: "POST", body: payload, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
    }
  } catch {
    /* tracking nunca quebra a venda */
  }
}
